import script from "./TTSProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./TTSProjects.vue?vue&type=script&setup=true&lang=js"

import "./TTSProjects.vue?vue&type=style&index=0&id=e5ab6590&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5ab6590"]])

export default __exports__